import { lighten, makeStyles } from "@material-ui/core";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

export const ResetStyle = makeStyles((theme) => ({
    root: {
        paddingTop: "2rem",
        paddingBottom: "2rem",
        borderBottom: "3px solid #000",
        "& > p": {
            margin: "0.5rem 0",
        },
    },
    bqsResetButton: {
        margin: "1rem 0.75rem !important",
        backgroundColor: "#33cc33",
        right: "0",
        "&:hover": {
            backgroundColor: lighten("#33cc33", 0.2),
        },
    },
}));
